(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sigenergy-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sigenergy-landing')) {
    customElements.define('sigenergy-landing', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cleanup = new AbortController();
        const signal = this.cleanup.signal;
        const video = this.querySelector('video');
        const button = this.querySelector('.sg-video-toggle');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = matchMedia('(max-width: 760px)');
        let manualPaused = false;
        const updateButton = () => {
          const paused = video.paused;
          button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
          button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        };
        const loadVideo = (userInitiated = false) => {
          const source = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
          if (!source) return;
          button.hidden = false;
          if (!userInitiated && (reduced.matches || navigator.connection?.saveData)) return;
          if (video.getAttribute('src') !== source) {
            video.classList.remove('is-ready');
            video.src = source;
            video.load();
          }
          if (!manualPaused) video.play().catch(updateButton);
        };
        video.addEventListener('playing', () => {video.classList.add('is-ready'); updateButton();}, {signal});
        video.addEventListener('pause', updateButton, {signal});
        video.addEventListener('error', () => {video.classList.remove('is-ready'); button.hidden = true;}, {signal});
        button.addEventListener('click', () => {
          if (video.paused) {manualPaused = false; loadVideo(true);} else {manualPaused = true; video.pause();}
        }, {signal});
        mobile.addEventListener('change', () => loadVideo(), {signal});
        reduced.addEventListener('change', () => {if (reduced.matches) {video.pause();} else loadVideo();}, {signal});
        document.addEventListener('visibilitychange', () => {if (document.hidden) video.pause(); else if (!manualPaused && !reduced.matches && this.heroVisible) loadVideo();}, {signal});
        this.heroObserver = new IntersectionObserver(([entry]) => {
          this.heroVisible = entry.isIntersecting;
          if (!entry.isIntersecting) video.pause();
          else if (!manualPaused) loadVideo();
        }, {threshold:0.1});
        this.heroObserver.observe(this.querySelector('.sg-hero'));
        this.querySelectorAll('[data-product-grid]').forEach(grid => {
          const cards = [...grid.querySelectorAll('.sg-card')];
          const toggle = grid.nextElementSibling;
          const limit = 6;
          if (cards.length <= limit) return;
          cards.slice(limit).forEach(card => card.hidden = true);
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(expanded));
            cards.slice(limit).forEach(card => card.hidden = !expanded);
            toggle.textContent = expanded ? toggle.dataset.less + ' −' : toggle.dataset.more + ' +';
          }, {signal});
        });
        const links = [...this.querySelectorAll('[data-section-link]')];
        const ranges = [...this.querySelectorAll('.sg-range')];
        const selectLink = () => {
          let current = ranges[0];
          for (const range of ranges) {if (range.getBoundingClientRect().top <= 160) current = range;}
          links.forEach(link => {
            if (link.hash === '#' + current.id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        let scheduled = false;
        window.addEventListener('scroll', () => {if (!scheduled) {scheduled = true;requestAnimationFrame(() => {selectLink();scheduled = false;});}}, {passive:true,signal});
        selectLink();
      }
      disconnectedCallback() {
        this.cleanup?.abort();
        this.heroObserver?.disconnect();
        this.querySelector('video')?.pause();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
